export default function getGroupTypeName(pathname: any) {
  if (pathname.includes('organizations')) {
    return 'GREEK_ORGANIZATION';
  } else if (pathname.includes('councils')) {
    return 'COUNCIL';
  } else {
    return 'GREEK_CHAPTER';
  }
}
